import React from 'react'

const StatCard = ({ emoji, value, label, variant = 'default', className = "" }) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'purple':
        return 'bg-purple-500/20 border-purple-500/30'
      case 'blue':
        return 'bg-blue-500/20 border-blue-500/30'
      case 'green':
        return 'bg-green-500/20 border-green-500/30'
      default:
        return 'bg-white/5 border-white/10'
    }
  }

  return (
    <div className={`text-center p-4 rounded-xl border ${getVariantStyles()} ${className}`}>
      {emoji && <div className="text-2xl mb-2">{emoji}</div>}
      <div className="text-2xl font-bold text-white mb-1">{value}</div>
      <div className="text-gray-300 text-sm">{label}</div>
    </div>
  )
}

export default StatCard